// extracted by mini-css-extract-plugin
export default {"body":"About_body__ooiRF","aboutImage":"About_aboutImage__Y9izp"};